/**
 * The block under the page header: every page has exactly one, whatever it
 * holds - an article beside its sidebar, a list, a grid of cards, a form.
 *
 * `className` says which of those it is (page-body--split, articles-list,
 * ...); everything else is passed through, so a page can still label its own
 * region for screen readers.
 */
function PageBody({ className, children, ...rest }) {
  return (
    <section
      className={['page-body', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </section>
  );
}

export default PageBody;
